import React, { useEffect } from 'react';
import {sendDataLayer} from '../../actions/gtmService';

const DataLayerTrigger = ({ event, data, triggerEvent, children }) => {

  useEffect(() => {
    // Trigger data push automatically on mount if no trigger event is provided
    if (!triggerEvent) {
      sendDataLayer(event, data);
    }
  }, []); // Run only once on mount

  const triggerProps = triggerEvent
    ? { [triggerEvent]: sendDataLayer }
    : {};

  return (
    <div {...triggerProps}>
      {children}
    </div>
  );
};

export default DataLayerTrigger;


//How to run it as element and on existing element
{/* <DataLayerTrigger event="OnLogivEvent" data={{ buttonLabel: 'Test' , seconeTestLabel: 'Test2'}} />
<DataLayerTrigger
event="O clickEvent"
data={{ buttonLabel: 'TestClick', secondTestLabel: 'Test2Click2' }}
triggerEvent="onClick"
>
<button>Click Me</button>
</DataLayerTrigger> */}


// WEBPACK FOOTER //
// ./src/components/app/GTM.jsx